"use strict";
var appn;
(function (appn) {
    var userGroupFilter;
    (function (userGroupFilter) {
        userGroupFilter.selectedGroupId = appn.emptyString;
        function init(reloadUrl, onAfterGroupChanged) {
            const groupIdFromUrl = appn.utils.getUrlParamByName('groupId');
            let value = getStateOrDefault().value;
            if (groupIdFromUrl)
                value = groupIdFromUrl;
            setValue(value);
            addEvents(reloadUrl);
        }
        userGroupFilter.init = init;
        function addEvents(reloadUrl) {
            $('.appnUserGroupFilter .appnUserGroupFilter-link').off().on('click', function (e) {
                e.preventDefault();
                setValue($(this).prop('id'));
            });
            $(document).on('hidden.bs.modal', function () {
                if (!appn.iframe.getHost().reloadFlag)
                    return;
                appn.location.navTo(reloadUrl);
            });
        }
        function getStateOrDefault() {
            const appnUserGroupFilter = $('.appnUserGroupFilter');
            return appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnUserGroupFilter), getValue());
        }
        userGroupFilter.getStateOrDefault = getStateOrDefault;
        function getValue() {
            const appnUserGroupFilter = $('.appnUserGroupFilter');
            const value = appnUserGroupFilter.find('li.active .appnUserGroupFilter-link').prop('id');
            if (value === 'appnUserGroupFilter-all')
                return appn.emptyString;
            return value;
        }
        userGroupFilter.getValue = getValue;
        function setValue(value) {
            appn.dataTable.uncheckAllRowsBox();
            userGroupFilter.selectedGroupId = !value || value === 'appnUserGroupFilter-all' ? appn.emptyString : value;
            if (getValue() === value)
                return;
            const appnUserGroupFilter = $('.appnUserGroupFilter');
            appnUserGroupFilter.find('li').removeClass('active');
            appnUserGroupFilter.find('#' + (!value ? 'appnUserGroupFilter-all' : value)).closest('li').addClass('active');
        }
        userGroupFilter.setValue = setValue;
        function reset() {
            setValue();
        }
        userGroupFilter.reset = reset;
        function listContains(value) {
            let exists = false;
            const templates = $('.appnUserGroupFilter .appnUserGroupFilter-link');
            $(templates).each(function () {
                if ((this).id === 'appnUserGroupFilter-all')
                    return true;
                if ((this).id === value) {
                    exists = true;
                    return false;
                }
                return true;
            });
            return exists;
        }
        userGroupFilter.listContains = listContains;
    })(userGroupFilter = appn.userGroupFilter || (appn.userGroupFilter = {}));
})(appn || (appn = {}));
